import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '@/stores/auth'

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      name: 'Home',
      component: () => import('@/views/HomeView.vue'),
    },
    {
      path: '/admin',
      name: 'Admin',
      component: () => import('@/views/AdminView.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/upload',
      name: 'Upload',
      component: () => import('@/views/UploadView.vue'),
    },
    {
      path: '/download',
      name: 'Download',
      component: () => import('@/views/DownloadView.vue'),
    },
    {
      path: '/login',
      name: 'Login',
      component: () => import('@/views/LoginView.vue'),
    },
    {
      path: '/auth/validate',
      name: 'ValidateAuth',
      component: () => import('@/views/ValidateAuthView.vue'),
    },
    {
      path: '/admin/auth',
      name: 'AdminAuth',
      component: () => import('@/views/ValidateAuthView.vue'),
    },
    {
      path: '/:pathMatch(.*)*',
      name: 'NotFound',
      component: () => import('@/views/NotFoundView.vue'),
    },
  ],
})

// Navigation guard for admin routes
router.beforeEach(async (to, from, next) => {
  if (to.meta.requiresAuth) {
    const authStore = useAuthStore()
    
    // Wait for auth initialization if still loading
    if (authStore.loading) {
      await authStore.initializeAuth()
    }
    
    if (!authStore.isAuthenticated) {
      next('/login')
      return
    }
    
    // For admin routes, validate token to prevent redirect loops
    if (to.path.startsWith('/admin')) {
      const { AuthService } = await import('@/services/auth')
      const isTokenValid = await AuthService.validateCurrentToken()
      
      if (!isTokenValid) {
        console.log('[Router] Token validation failed - redirecting to login')
        // Clear auth state to prevent loops
        authStore.signOut()
        next('/login')
        return
      }
    }
  }
  
  // Prevent redirect loops between login and dashboard
  if (to.path === '/login' && from.path === '/admin' && from.path !== to.path) {
    console.log('[Router] Preventing login/admin redirect loop')
    return
  }
  
  next()
})

export default router
